import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faSignOutAlt,
  faMoneyBillWave,
  faTag,
  faDoorOpen,
  faTools,
  faHouseUser,
  faHistory,
  faFileInvoiceDollar,
  faFaucetDrip,
  faBell,
  faHandshakeAngle,
  faMoneyBillTransfer, // Added a more suitable icon for transactions
  faReceipt, // Alternative for deposits/withdrawals if desired
} from "@fortawesome/free-solid-svg-icons"; // Corrected imports based on your provided list
import { AuthGuard } from "../App";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MyApartment = () => {
  const userDataString = localStorage.getItem("user");
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const userData = JSON.parse(userDataString);
  const userId = userData.unique;
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userName = userData?.fullName || "User";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("Token is missing.");
          return;
        }

        const notificationsResponse = await axios.get(
          "https://backend.inyumba.co.ke/iNyumba/inappnotifications/viewallnotifications",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setNotificationsCount(notificationsResponse.data.response.length);
        setNotifications(notificationsResponse.data.response);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchData();
  }, []);

  const toggleNotifications = () => {
    setIsNotificationsOpen(!isNotificationsOpen);
  };

  const handleBillPaymentsClick = () => {
    navigate("/user/bills");
  };

  const handleVacatingClick = () => {
    navigate("/user/viewvacate");
  };

  const handleWaterbillClick = () => {
    navigate("/user/waterbill");
  };

  const handleReservationClick = () => {
    navigate("/user/reservation");
  };

  const handleMaintenanceRequestClick = () => {
    navigate("/user/maintenancerequest");
  };

  const handlePreviousReservationsClick = () => {
    navigate("/user/previousreservation");
  };

  const handleProfileClick = () => {
    navigate("/user/profile");
  };

  const handleLogoutClick = () => {
    navigate("/logout");
  };

  const handleSettlementRecords = () => {
    navigate("/user/settlement");
  };

  const handleWithdrawalsClick = () => {
    navigate("/user/withdrawals");
  };

  const handleAgencyFeeClick = () => {
    navigate("/user/agencyviewingfee");
  };

  const handlePromoCodeClick = () => {
    navigate("/user/promocode");
  };
  const handleDepositClick = () => {
    navigate("/user/deposits");
  };

  return (
    <AuthGuard>
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-indigo-50 to-blue-100 p-4 sm:p-6 lg:p-10 flex flex-col items-center">
        
        {/* Top Header with Profile, Notifications, Logout */}
        <header className="w-full max-w-7xl flex items-center justify-between py-4 px-6 bg-white bg-opacity-90 backdrop-blur-md rounded-full shadow-lg mb-10 animate-fade-in-down border border-gray-100">
          {/* Left Section - Profile & App Title */}
          <div className="flex items-center space-x-4">
            <div
              className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-purple-200 to-indigo-200 text-purple-700 cursor-pointer
                         hover:from-purple-300 hover:to-indigo-300 transition-all duration-300 transform hover:scale-105 shadow-md"
              onClick={handleProfileClick}
              aria-label="User Profile"
            >
              <FontAwesomeIcon icon={faUser} className="text-xl" />
            </div>
            <h1 className="hidden sm:block text-2xl font-bold text-gray-800">iNyumba</h1>
          </div>

          {/* Right Section - Notifications & Logout */}
          <div className="flex items-center space-x-4">
            <div className="relative">
              <div
                className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-blue-200 to-cyan-200 text-blue-700 cursor-pointer
                           hover:from-blue-300 hover:to-cyan-300 transition-all duration-300 transform hover:scale-105 shadow-md"
                onClick={toggleNotifications}
                aria-label="View Notifications"
              >
                <FontAwesomeIcon icon={faBell} className="text-xl" />
              </div>
              {notificationsCount > 0 && (
                <span className="absolute -top-1 -right-1 text-xs font-bold bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center ring-2 ring-white animate-pulse">
                  {notificationsCount}
                </span>
              )}
              {/* Notifications Dropdown */}
              {isNotificationsOpen && (
                <div className="absolute top-14 right-0 w-72 bg-white text-gray-800 p-4 rounded-xl shadow-2xl border border-gray-100 z-50 max-h-72 overflow-y-auto transform origin-top-right animate-scale-in">
                  <h3 className="font-extrabold text-lg mb-3 pb-2 border-b-2 border-indigo-200 text-indigo-700">Notifications</h3>
                  {notifications.length > 0 ? (
                    notifications.map((notification) => (
                      <div key={notification.notificationid} className="mb-2 p-3 bg-gray-50 rounded-lg text-sm transition-colors duration-200 hover:bg-gray-100">
                        {notification.notification}
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 text-center py-4">No new notifications.</p>
                  )}
                </div>
              )}
            </div>

            <div
              className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-red-200 to-pink-200 text-red-700 cursor-pointer
                         hover:from-red-300 hover:to-pink-300 transition-all duration-300 transform hover:scale-105 shadow-md"
              onClick={handleLogoutClick}
              aria-label="Log Out"
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="text-xl" />
            </div>
          </div>
        </header>

        {/* Welcome Greeting */}
        <section className="text-center mb-12 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight drop-shadow-sm">
            Hello, <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600">{userName}!</span> ✨
          </h2>
          <p className="mt-3 text-lg sm:text-xl text-gray-700">
            Welcome back to your comprehensive apartment dashboard.
          </p>
        </section>

        {/* Grid Container for Feature Cards */}
        <main className="w-full max-w-7xl grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8 xl:gap-10 animate-fade-in-up">
          {[
            {
              icon: faMoneyBillWave,
              label: "Bill Payments",
              onClick: handleBillPaymentsClick,
              color: "purple",
              gradient: "from-purple-500 to-purple-600",
            },
            {
              icon: faHandshakeAngle,
              label: "House Hunting Fee",
              onClick: handleAgencyFeeClick,
              color: "green",
              gradient: "from-emerald-500 to-emerald-600",
            },
            {
              icon: faMoneyBillTransfer, // Changed to a more suitable icon
              label: "Withdrawals",
              onClick: handleWithdrawalsClick,
              color: "orange",
              gradient: "from-orange-500 to-orange-600",
            },
            {
              icon: faTag,
              label: "Promo Code",
              onClick: handlePromoCodeClick,
              color: "pink",
              gradient: "from-pink-500 to-pink-600",
            },
            {
              icon: faReceipt, // Changed to a more suitable icon for deposits (receipt implies transaction record)
              label: "Deposits",
              onClick: handleDepositClick,
              color: "blue",
              gradient: "from-blue-500 to-blue-600",
            },
            {
              icon: faHouseUser,
              label: "My Apartment",
              onClick: handleReservationClick,
              color: "indigo",
              gradient: "from-indigo-500 to-indigo-600",
            },
            {
              icon: faTools,
              label: "Maintenance Requests",
              onClick: handleMaintenanceRequestClick,
              color: "red",
              gradient: "from-red-500 to-red-600",
            },
            {
              icon: faDoorOpen,
              label: "Vacating",
              onClick: handleVacatingClick,
              color: "yellow",
              gradient: "from-yellow-500 to-yellow-600",
            },
            {
              icon: faFaucetDrip,
              label: "Water Bill",
              onClick: handleWaterbillClick,
              color: "cyan",
              gradient: "from-cyan-500 to-cyan-600",
            },
            {
              icon: faFileInvoiceDollar,
              label: "Settlement Records",
              onClick: handleSettlementRecords,
              color: "teal",
              gradient: "from-teal-500 to-teal-600",
            },
            {
              icon: faHistory,
              label: "Previous Reservations",
              onClick: handlePreviousReservationsClick,
              color: "gray",
              gradient: "from-gray-500 to-gray-600",
            },
          ].map(({ icon, label, onClick, color, gradient }, index) => (
            <div
              key={index}
              className={`relative flex flex-col items-center justify-center p-6 sm:p-8 bg-white rounded-3xl shadow-xl cursor-pointer
                         transform transition-all duration-300 ease-in-out hover:-translate-y-2 hover:shadow-2xl hover:border-transparent group
                         border-b-4 border-${color}-400 overflow-hidden`}
              onClick={onClick}
            >
              {/* Card background overlay on hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-3xl`}></div>

              <div
                className={`relative z-10 flex items-center justify-center w-18 h-18 sm:w-20 sm:h-20 rounded-full mb-4 sm:mb-5 shadow-lg
                           bg-gradient-to-br from-${color}-100 to-${color}-200 text-${color}-700
                           group-hover:text-white group-hover:from-${color}-400 group-hover:to-${color}-500
                           transition-all duration-300`}
              >
                <FontAwesomeIcon icon={icon} className="text-3xl sm:text-4xl" />
              </div>
              <div className="relative z-10 text-center text-lg sm:text-xl font-bold text-gray-800 group-hover:text-gray-900 transition-colors duration-300">
                {label}
              </div>
            </div>
          ))}
        </main>
      </div>
    </AuthGuard>
  );
};

export default MyApartment;